export default __webpack_public_path__ + "static/Graphik-Light-Web-05a682353acde67bf6e2c6312a65bc80.svg";